<template>
  <zm-popover
    placement="bottom"
    :aria-label="t('aria.coachMark.tryNewExperienceAria')"
    :disabled="enableNewExperience"
    :z-index="301"
    trigger="hover"
    allow-focus-out
    read-description
    :title="t('coachMark.tryNewExperienceTitle')"
    floating-content-class="new-experience-toggle-popover"
    :dialog-style="{ 'min-width': '320px' }">
    <span class="new-experience-toggle" :tabindex="enableNewExperience ? -1 : 0">
      <span id="new-experience-toggle-text" class="new-experience-toggle-text">
        {{ t('coachMark.tryNewExperience') }}
      </span>

      <zm-toggle
        v-model="enableNewExperience"
        :loading="isLoading"
        size="sm"
        aria-labelledby="new-experience-toggle-text"
        @change="handleChange"
        @keydown.space.stop />
    </span>
    <template #content>
      <p class="new-experience-toggle-content-description">
        {{ t('coachMark.tryNewExperienceDetail') }}
      </p>
    </template>
  </zm-popover>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { ZmToggle, ZmPopover, ZmToast } from '@zoom/zoom-ui-vue3'
import { trackEvent } from '../../../shared/event-tracker'
import { createAppI18n } from '../../../shared/setup-i18n'

const { t } = createAppI18n('coachMark').global

defineOptions({
  name: 'try-new-experience-toggle'
})

const props = defineProps({
  enable: {
    type: Boolean
  }
})
const enableNewExperience = ref(props.enable)
const isLoading = ref(false)
const handleChange = () => {
  trackEvent({
    linkText: `try new experience - ${props.enable ? 'off' : 'on'}`,
    linkUrl: 'undefined',
    uiLocation: 'universal nav'
  })
  isLoading.value = true
  axios
    .post(
      '/waffle/save_simplified_portal_enabled',
      {
        simplifiedPortalEnabled: !props.enable
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    )
    .then(() => {
      window.location.reload()
    })
    .catch((error) => {
      isLoading.value = false
      enableNewExperience.value = props.enable
      ZmToast({
        message: error.message,
        type: 'danger'
      })
    })
}
</script>

<style lang="scss">
.new-experience-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 20px;
  position: relative;
  padding-right: 12px;
  &::after {
    content: '';
    position: absolute;
    top: 4px;
    right: 0;
    width: 1px;
    height: 12px;
    background-color: var(--zoom-color-border-subtle-neutral, #dfe3e8);
  }
  .fe-popups-toggle {
    margin-bottom: 0;
  }
  .new-experience-toggle-text {
    display: inline-block;
    color: inherit;
    font-weight: 400;
    font-size: 14px;
  }
  .new-experience-toggle-button {
    color: #8e9194;
  }
}

.new-experience-toggle-popover {
  .fe-popups-popover:focus-visible {
    outline: none;
  }
}

.new-experience-toggle-content-description {
  font-weight: 400;
  margin-bottom: 0;
}
.is-brand-color-applied {
  .new-experience-toggle-text {
    color: inherit;
  }
}
</style>
